import { Link } from 'react-router-dom';
import EmptyState from '@/components/common/EmptyState';
import { roleLabel } from '@/lib/role';
import { useAuthStore } from '@/store/authStore';

export default function ProfilePage() {
  const user = useAuthStore(state => state.user);

  if (!user) {
    return (
      <div className="max-w-[980px] mx-auto px-6 py-12">
        <EmptyState title="未找到用户信息" description="请重新登录后查看个人资料。" />
      </div>
    );
  }

  const initial = user.name?.charAt(0).toUpperCase() ?? 'U';

  return (
    <div className="max-w-[980px] mx-auto px-6 py-12">
      <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="font-semibold text-apple-near-black text-[2rem] leading-tight tracking-tight">
            个人资料
          </h1>
          <p className="mt-1 text-[0.9375rem] text-apple-gray">
            查看当前账户信息。资料修改请前往设置页面。
          </p>
        </div>
        <Link to="/settings/profile" className="btn btn-secondary self-start sm:self-auto">
          编辑资料
        </Link>
      </div>

      <section className="max-w-[640px] bg-white rounded-2xl p-6 sm:p-8 shadow-card-sm">
        <div className="flex items-center gap-5 mb-8">
          <div className="w-16 h-16 rounded-full bg-apple-blue flex items-center justify-center text-white text-[1.5rem] font-semibold shrink-0">
            {initial}
          </div>
          <div>
            <h2 className="font-semibold text-apple-near-black text-[1.3125rem] leading-tight">
              {user.name}
            </h2>
            <p className="text-apple-gray text-[0.9375rem]">{user.email}</p>
          </div>
        </div>

        <dl className="divide-y divide-apple-border border-y border-apple-border">
          <div className="flex justify-between gap-4 py-4">
            <dt className="text-apple-gray text-[0.9375rem]">邮箱</dt>
            <dd className="text-right text-apple-near-black text-[0.9375rem]">{user.email}</dd>
          </div>
          <div className="flex justify-between gap-4 py-4">
            <dt className="text-apple-gray text-[0.9375rem]">身份</dt>
            <dd className="text-right text-apple-near-black text-[0.9375rem]">
              {roleLabel(user.role)}
            </dd>
          </div>
          <div className="flex justify-between gap-4 py-4">
            <dt className="text-apple-gray text-[0.9375rem]">注册时间</dt>
            <dd className="text-right text-apple-near-black text-[0.9375rem]">
              {user.createdAt ? new Date(user.createdAt).toLocaleDateString('zh-CN') : '-'}
            </dd>
          </div>
        </dl>
      </section>
    </div>
  );
}
